const typeNamespace = 'AUTH_';

export const REQUEST = `${typeNamespace}REQUEST`;
export const LOGIN_REQUEST = `${typeNamespace}LOGIN_REQUEST`;
export const LOG_OUT = `${typeNamespace}LOG_OUT`;
export const REFRESH_TOKEN = `${typeNamespace}REFRESH_TOKEN`;
